import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const stackingCards = () => {

	const mm = gsap.matchMedia();

	mm.add("(min-width: 768px)", () => {

		const timelines = [];
		const stackStates = [];

		document.querySelectorAll(".stacking-cards").forEach((stack) => {

			const cards = [...stack.children];

			stackStates.push({
				stack,
				stackStyle: stack.getAttribute("style"),
				cards: cards.map((card) => ({
					card,
					style: card.getAttribute("style")
				}))
			});

			const maxHeight = Math.max(
				...cards.map(card => card.scrollHeight)
			);

			cards.forEach(card => {
				card.style.height = `${maxHeight}px`;
			});

			stack.style.height = `${maxHeight}px`;

			gsap.set(cards, { clearProps: "all" });

			cards.forEach((card, index) => {
				gsap.set(card, {
					zIndex: index + 1,
					yPercent: index === 0 ? 0 : 100,
					autoAlpha: index === 0 ? 1 : 0
				});
			});

			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: stack,
					start: "top 100px",
					end: `+=${cards.length * 500}`,
					pin: true,
					scrub: true,
					invalidateOnRefresh: true
				}
			});

			timelines.push(tl);

			tl.to({}, { duration: 0.4 });

			cards.forEach((card, index) => {

				if (index === cards.length - 1) return;

				tl.to(card, {
					opacity: 0,
					yPercent: -8,
					scale: 0.97,
					duration: 1
				}, `card-${index}`);

				tl.fromTo(
					cards[index + 1],
					{
						autoAlpha: 0,
						yPercent: 40,
						scale: 0.96
					},
					{
						autoAlpha: 1,
						yPercent: 0,
						scale: 1,
						duration: 0.8
					},
					`card-${index}+=0.2`
				);

			});

		});

		return () => {

			timelines.forEach((timeline) => {
				timeline.scrollTrigger?.kill(true);
				timeline.kill();
			});

			requestAnimationFrame(() => {
				stackStates.forEach(({ stack, stackStyle, cards }) => {
					restoreStyleAttribute(stack, stackStyle);

					cards.forEach(({ card, style }) => {
						restoreStyleAttribute(card, style);
					});
				});

				ScrollTrigger.refresh();
			});

		};

	});

};

const restoreStyleAttribute = (element, style) => {
	if (style === null) {
		element.removeAttribute("style");
		return;
	}

	element.setAttribute("style", style);
};

export { stackingCards };
